var _rect, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgListUnchecked(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.666626,
    width: 32,
    height: 32,
    rx: 4.8,
    fill: "#F1F8FD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1666 9.5C9.32288 9.5 8.66663 10.1875 8.66663 11C8.66663 11.8438 9.32288 12.5 10.1666 12.5C10.9791 12.5 11.6666 11.8438 11.6666 11C11.6666 10.1875 10.9791 9.5 10.1666 9.5ZM10.1666 14.5C9.32288 14.5 8.66663 15.1875 8.66663 16C8.66663 16.8438 9.32288 17.5 10.1666 17.5C10.9791 17.5 11.6666 16.8438 11.6666 16C11.6666 15.1875 10.9791 14.5 10.1666 14.5ZM10.1666 19.5C9.32288 19.5 8.66663 20.1875 8.66663 21C8.66663 21.8438 9.32288 22.5 10.1666 22.5C10.9791 22.5 11.6666 21.8438 11.6666 21C11.6666 20.1875 10.9791 19.5 10.1666 19.5ZM24.1666 20H14.1666C13.8854 20 13.6666 20.25 13.6666 20.5V21.5C13.6666 21.7812 13.8854 22 14.1666 22H24.1666C24.4166 22 24.6666 21.7812 24.6666 21.5V20.5C24.6666 20.25 24.4166 20 24.1666 20ZM24.1666 10H14.1666C13.8854 10 13.6666 10.25 13.6666 10.5V11.5C13.6666 11.7812 13.8854 12 14.1666 12H24.1666C24.4166 12 24.6666 11.7812 24.6666 11.5V10.5C24.6666 10.25 24.4166 10 24.1666 10ZM24.1666 15H14.1666C13.8854 15 13.6666 15.25 13.6666 15.5V16.5C13.6666 16.7812 13.8854 17 14.1666 17H24.1666C24.4166 17 24.6666 16.7812 24.6666 16.5V15.5C24.6666 15.25 24.4166 15 24.1666 15Z",
    fill: "#0A3751"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgListUnchecked);
export default __webpack_public_path__ + "static/media/list-unchecked.1af7c8ad1210c76b5d1b73206b09b1ba.svg";
export { ForwardRef as ReactComponent };